module.exports = __webpack_public_path__ + "assets/img/Ic_exclamation-marks-green.27db888b.svg";